// League of Legends champion data — Data Dragon 16.8.1 (172 champions)
export const HeroData = {
  aatrox: {
    id: "Aatrox",
    name: "Aatrox",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Aatrox.png`
  },
  ahri: {
    id: "Ahri",
    name: "Ahri",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Ahri.png`
  },
  akali: {
    id: "Akali",
    name: "Akali",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Akali.png`
  },
  akshan: {
    id: "Akshan",
    name: "Akshan",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Akshan.png`
  },
  alistar: {
    id: "Alistar",
    name: "Alistar",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Alistar.png`
  },
  ambessa: {
    id: "Ambessa",
    name: "Ambessa",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Ambessa.png`
  },
  amumu: {
    id: "Amumu",
    name: "Amumu",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Amumu.png`
  },
  anivia: {
    id: "Anivia",
    name: "Anivia",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Anivia.png`
  },
  annie: {
    id: "Annie",
    name: "Annie",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Annie.png`
  },
  aphelios: {
    id: "Aphelios",
    name: "Aphelios",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Aphelios.png`
  },
  ashe: {
    id: "Ashe",
    name: "Ashe",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Ashe.png`
  },
  aurelionsol: {
    id: "AurelionSol",
    name: "Aurelion Sol",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/AurelionSol.png`
  },
  aurora: {
    id: "Aurora",
    name: "Aurora",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Aurora.png`
  },
  azir: {
    id: "Azir",
    name: "Azir",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Azir.png`
  },
  bard: {
    id: "Bard",
    name: "Bard",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Bard.png`
  },
  belveth: {
    id: "Belveth",
    name: "Bel'Veth",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Belveth.png`
  },
  blitzcrank: {
    id: "Blitzcrank",
    name: "Blitzcrank",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Blitzcrank.png`
  },
  brand: {
    id: "Brand",
    name: "Brand",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Brand.png`
  },
  braum: {
    id: "Braum",
    name: "Braum",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Braum.png`
  },
  briar: {
    id: "Briar",
    name: "Briar",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Briar.png`
  },
  caitlyn: {
    id: "Caitlyn",
    name: "Caitlyn",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Caitlyn.png`
  },
  camille: {
    id: "Camille",
    name: "Camille",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Camille.png`
  },
  cassiopeia: {
    id: "Cassiopeia",
    name: "Cassiopeia",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Cassiopeia.png`
  },
  chogath: {
    id: "Chogath",
    name: "Cho'Gath",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Chogath.png`
  },
  corki: {
    id: "Corki",
    name: "Corki",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Corki.png`
  },
  darius: {
    id: "Darius",
    name: "Darius",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Darius.png`
  },
  diana: {
    id: "Diana",
    name: "Diana",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Diana.png`
  },
  drmundo: {
    id: "DrMundo",
    name: "Dr. Mundo",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/DrMundo.png`
  },
  draven: {
    id: "Draven",
    name: "Draven",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Draven.png`
  },
  ekko: {
    id: "Ekko",
    name: "Ekko",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Ekko.png`
  },
  elise: {
    id: "Elise",
    name: "Elise",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Elise.png`
  },
  evelynn: {
    id: "Evelynn",
    name: "Evelynn",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Evelynn.png`
  },
  ezreal: {
    id: "Ezreal",
    name: "Ezreal",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Ezreal.png`
  },
  fiddlesticks: {
    id: "Fiddlesticks",
    name: "Fiddlesticks",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Fiddlesticks.png`
  },
  fiora: {
    id: "Fiora",
    name: "Fiora",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Fiora.png`
  },
  fizz: {
    id: "Fizz",
    name: "Fizz",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Fizz.png`
  },
  galio: {
    id: "Galio",
    name: "Galio",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Galio.png`
  },
  gangplank: {
    id: "Gangplank",
    name: "Gangplank",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Gangplank.png`
  },
  garen: {
    id: "Garen",
    name: "Garen",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Garen.png`
  },
  gnar: {
    id: "Gnar",
    name: "Gnar",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Gnar.png`
  },
  gragas: {
    id: "Gragas",
    name: "Gragas",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Gragas.png`
  },
  graves: {
    id: "Graves",
    name: "Graves",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Graves.png`
  },
  gwen: {
    id: "Gwen",
    name: "Gwen",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Gwen.png`
  },
  hecarim: {
    id: "Hecarim",
    name: "Hecarim",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Hecarim.png`
  },
  heimerdinger: {
    id: "Heimerdinger",
    name: "Heimerdinger",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Heimerdinger.png`
  },
  hwei: {
    id: "Hwei",
    name: "Hwei",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Hwei.png`
  },
  illaoi: {
    id: "Illaoi",
    name: "Illaoi",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Illaoi.png`
  },
  irelia: {
    id: "Irelia",
    name: "Irelia",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Irelia.png`
  },
  ivern: {
    id: "Ivern",
    name: "Ivern",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Ivern.png`
  },
  janna: {
    id: "Janna",
    name: "Janna",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Janna.png`
  },
  jarvaniv: {
    id: "JarvanIV",
    name: "Jarvan IV",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/JarvanIV.png`
  },
  jax: {
    id: "Jax",
    name: "Jax",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Jax.png`
  },
  jayce: {
    id: "Jayce",
    name: "Jayce",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Jayce.png`
  },
  jhin: {
    id: "Jhin",
    name: "Jhin",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Jhin.png`
  },
  jinx: {
    id: "Jinx",
    name: "Jinx",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Jinx.png`
  },
  ksante: {
    id: "KSante",
    name: "K'Sante",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/KSante.png`
  },
  kaisa: {
    id: "Kaisa",
    name: "Kai'Sa",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Kaisa.png`
  },
  kalista: {
    id: "Kalista",
    name: "Kalista",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Kalista.png`
  },
  karma: {
    id: "Karma",
    name: "Karma",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Karma.png`
  },
  karthus: {
    id: "Karthus",
    name: "Karthus",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Karthus.png`
  },
  kassadin: {
    id: "Kassadin",
    name: "Kassadin",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Kassadin.png`
  },
  katarina: {
    id: "Katarina",
    name: "Katarina",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Katarina.png`
  },
  kayle: {
    id: "Kayle",
    name: "Kayle",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Kayle.png`
  },
  kayn: {
    id: "Kayn",
    name: "Kayn",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Kayn.png`
  },
  kennen: {
    id: "Kennen",
    name: "Kennen",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Kennen.png`
  },
  khazix: {
    id: "Khazix",
    name: "Kha'Zix",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Khazix.png`
  },
  kindred: {
    id: "Kindred",
    name: "Kindred",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Kindred.png`
  },
  kled: {
    id: "Kled",
    name: "Kled",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Kled.png`
  },
  kogmaw: {
    id: "KogMaw",
    name: "Kog'Maw",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/KogMaw.png`
  },
  leblanc: {
    id: "Leblanc",
    name: "LeBlanc",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Leblanc.png`
  },
  leesin: {
    id: "LeeSin",
    name: "Lee Sin",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/LeeSin.png`
  },
  leona: {
    id: "Leona",
    name: "Leona",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Leona.png`
  },
  lillia: {
    id: "Lillia",
    name: "Lillia",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Lillia.png`
  },
  lissandra: {
    id: "Lissandra",
    name: "Lissandra",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Lissandra.png`
  },
  lucian: {
    id: "Lucian",
    name: "Lucian",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Lucian.png`
  },
  lulu: {
    id: "Lulu",
    name: "Lulu",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Lulu.png`
  },
  lux: {
    id: "Lux",
    name: "Lux",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Lux.png`
  },
  malphite: {
    id: "Malphite",
    name: "Malphite",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Malphite.png`
  },
  malzahar: {
    id: "Malzahar",
    name: "Malzahar",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Malzahar.png`
  },
  maokai: {
    id: "Maokai",
    name: "Maokai",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Maokai.png`
  },
  masteryi: {
    id: "MasterYi",
    name: "Master Yi",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/MasterYi.png`
  },
  mel: {
    id: "Mel",
    name: "Mel",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Mel.png`
  },
  milio: {
    id: "Milio",
    name: "Milio",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Milio.png`
  },
  missfortune: {
    id: "MissFortune",
    name: "Miss Fortune",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/MissFortune.png`
  },
  monkeyking: {
    id: "MonkeyKing",
    name: "Wukong",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/MonkeyKing.png`
  },
  mordekaiser: {
    id: "Mordekaiser",
    name: "Mordekaiser",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Mordekaiser.png`
  },
  morgana: {
    id: "Morgana",
    name: "Morgana",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Morgana.png`
  },
  naafiri: {
    id: "Naafiri",
    name: "Naafiri",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Naafiri.png`
  },
  nami: {
    id: "Nami",
    name: "Nami",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Nami.png`
  },
  nasus: {
    id: "Nasus",
    name: "Nasus",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Nasus.png`
  },
  nautilus: {
    id: "Nautilus",
    name: "Nautilus",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Nautilus.png`
  },
  neeko: {
    id: "Neeko",
    name: "Neeko",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Neeko.png`
  },
  nidalee: {
    id: "Nidalee",
    name: "Nidalee",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Nidalee.png`
  },
  nilah: {
    id: "Nilah",
    name: "Nilah",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Nilah.png`
  },
  nocturne: {
    id: "Nocturne",
    name: "Nocturne",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Nocturne.png`
  },
  nunu: {
    id: "Nunu",
    name: "Nunu & Willump",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Nunu.png`
  },
  olaf: {
    id: "Olaf",
    name: "Olaf",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Olaf.png`
  },
  orianna: {
    id: "Orianna",
    name: "Orianna",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Orianna.png`
  },
  ornn: {
    id: "Ornn",
    name: "Ornn",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Ornn.png`
  },
  pantheon: {
    id: "Pantheon",
    name: "Pantheon",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Pantheon.png`
  },
  poppy: {
    id: "Poppy",
    name: "Poppy",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Poppy.png`
  },
  pyke: {
    id: "Pyke",
    name: "Pyke",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Pyke.png`
  },
  qiyana: {
    id: "Qiyana",
    name: "Qiyana",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Qiyana.png`
  },
  quinn: {
    id: "Quinn",
    name: "Quinn",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Quinn.png`
  },
  rakan: {
    id: "Rakan",
    name: "Rakan",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Rakan.png`
  },
  rammus: {
    id: "Rammus",
    name: "Rammus",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Rammus.png`
  },
  reksai: {
    id: "RekSai",
    name: "Rek'Sai",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/RekSai.png`
  },
  rell: {
    id: "Rell",
    name: "Rell",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Rell.png`
  },
  renata: {
    id: "Renata",
    name: "Renata Glasc",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Renata.png`
  },
  renekton: {
    id: "Renekton",
    name: "Renekton",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Renekton.png`
  },
  rengar: {
    id: "Rengar",
    name: "Rengar",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Rengar.png`
  },
  riven: {
    id: "Riven",
    name: "Riven",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Riven.png`
  },
  rumble: {
    id: "Rumble",
    name: "Rumble",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Rumble.png`
  },
  ryze: {
    id: "Ryze",
    name: "Ryze",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Ryze.png`
  },
  samira: {
    id: "Samira",
    name: "Samira",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Samira.png`
  },
  sejuani: {
    id: "Sejuani",
    name: "Sejuani",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Sejuani.png`
  },
  senna: {
    id: "Senna",
    name: "Senna",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Senna.png`
  },
  seraphine: {
    id: "Seraphine",
    name: "Seraphine",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Seraphine.png`
  },
  sett: {
    id: "Sett",
    name: "Sett",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Sett.png`
  },
  shaco: {
    id: "Shaco",
    name: "Shaco",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Shaco.png`
  },
  shen: {
    id: "Shen",
    name: "Shen",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Shen.png`
  },
  shyvana: {
    id: "Shyvana",
    name: "Shyvana",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Shyvana.png`
  },
  singed: {
    id: "Singed",
    name: "Singed",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Singed.png`
  },
  sion: {
    id: "Sion",
    name: "Sion",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Sion.png`
  },
  sivir: {
    id: "Sivir",
    name: "Sivir",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Sivir.png`
  },
  skarner: {
    id: "Skarner",
    name: "Skarner",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Skarner.png`
  },
  smolder: {
    id: "Smolder",
    name: "Smolder",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Smolder.png`
  },
  sona: {
    id: "Sona",
    name: "Sona",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Sona.png`
  },
  soraka: {
    id: "Soraka",
    name: "Soraka",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Soraka.png`
  },
  swain: {
    id: "Swain",
    name: "Swain",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Swain.png`
  },
  sylas: {
    id: "Sylas",
    name: "Sylas",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Sylas.png`
  },
  syndra: {
    id: "Syndra",
    name: "Syndra",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Syndra.png`
  },
  tahmkench: {
    id: "TahmKench",
    name: "Tahm Kench",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/TahmKench.png`
  },
  taliyah: {
    id: "Taliyah",
    name: "Taliyah",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Taliyah.png`
  },
  talon: {
    id: "Talon",
    name: "Talon",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Talon.png`
  },
  taric: {
    id: "Taric",
    name: "Taric",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Taric.png`
  },
  teemo: {
    id: "Teemo",
    name: "Teemo",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Teemo.png`
  },
  thresh: {
    id: "Thresh",
    name: "Thresh",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Thresh.png`
  },
  tristana: {
    id: "Tristana",
    name: "Tristana",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Tristana.png`
  },
  trundle: {
    id: "Trundle",
    name: "Trundle",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Trundle.png`
  },
  tryndamere: {
    id: "Tryndamere",
    name: "Tryndamere",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Tryndamere.png`
  },
  twistedfate: {
    id: "TwistedFate",
    name: "Twisted Fate",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/TwistedFate.png`
  },
  twitch: {
    id: "Twitch",
    name: "Twitch",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Twitch.png`
  },
  udyr: {
    id: "Udyr",
    name: "Udyr",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Udyr.png`
  },
  urgot: {
    id: "Urgot",
    name: "Urgot",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Urgot.png`
  },
  varus: {
    id: "Varus",
    name: "Varus",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Varus.png`
  },
  vayne: {
    id: "Vayne",
    name: "Vayne",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Vayne.png`
  },
  veigar: {
    id: "Veigar",
    name: "Veigar",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Veigar.png`
  },
  velkoz: {
    id: "Velkoz",
    name: "Vel'Koz",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Velkoz.png`
  },
  vex: {
    id: "Vex",
    name: "Vex",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Vex.png`
  },
  vi: {
    id: "Vi",
    name: "Vi",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Vi.png`
  },
  viego: {
    id: "Viego",
    name: "Viego",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Viego.png`
  },
  viktor: {
    id: "Viktor",
    name: "Viktor",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Viktor.png`
  },
  vladimir: {
    id: "Vladimir",
    name: "Vladimir",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Vladimir.png`
  },
  volibear: {
    id: "Volibear",
    name: "Volibear",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Volibear.png`
  },
  warwick: {
    id: "Warwick",
    name: "Warwick",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Warwick.png`
  },
  xayah: {
    id: "Xayah",
    name: "Xayah",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Xayah.png`
  },
  xerath: {
    id: "Xerath",
    name: "Xerath",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Xerath.png`
  },
  xinzhao: {
    id: "XinZhao",
    name: "Xin Zhao",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/XinZhao.png`
  },
  yasuo: {
    id: "Yasuo",
    name: "Yasuo",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Yasuo.png`
  },
  yone: {
    id: "Yone",
    name: "Yone",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Yone.png`
  },
  yorick: {
    id: "Yorick",
    name: "Yorick",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Yorick.png`
  },
  yunara: {
    id: "Yunara",
    name: "Yunara",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Yunara.png`
  },
  yuumi: {
    id: "Yuumi",
    name: "Yuumi",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Yuumi.png`
  },
  zaahen: {
    id: "Zaahen",
    name: "Zaahen",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Zaahen.png`
  },
  zac: {
    id: "Zac",
    name: "Zac",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Zac.png`
  },
  zed: {
    id: "Zed",
    name: "Zed",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Zed.png`
  },
  zeri: {
    id: "Zeri",
    name: "Zeri",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Zeri.png`
  },
  ziggs: {
    id: "Ziggs",
    name: "Ziggs",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Ziggs.png`
  },
  zilean: {
    id: "Zilean",
    name: "Zilean",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Zilean.png`
  },
  zoe: {
    id: "Zoe",
    name: "Zoe",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Zoe.png`
  },
  zyra: {
    id: "Zyra",
    name: "Zyra",
    imageUrl: `https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Zyra.png`
  },
};

export default {
  HeroData,
  getHeroById: (id) => HeroData[id.toLowerCase()] || null,
  getHeroByName: (name) => {
    const key = Object.keys(HeroData).find(k =>
      HeroData[k].name.toLowerCase() === name.toLowerCase()
    );
    return key ? HeroData[key] : null;
  },
  getAllHeroNames: () => {
    const uniqueNames = new Set();
    Object.values(HeroData).forEach(c => uniqueNames.add(c.name));
    return Array.from(uniqueNames).sort();
  }
};
